import { addNotification } from 'reapop';
import get from 'lodash/get';

import {
  REQUEST_BENEFITS,
  REQUEST_BENEFITS_SUCCESS,
  REQUEST_BENEFITS_FAILURE,
  FITNESS_GRANT_REGISTER_REQUEST,
  FITNESS_GRANT_REGISTER_SUCCESS,
  FITNESS_GRANT_REGISTER_FAILURE,
  GRANT_REGISTER_REQUEST,
  GRANT_REGISTER_SUCCESS,
  GRANT_REGISTER_FAILURE
} from 'constants/ActionTypes';

import { custom, create } from 'utils/Api';
import { find } from 'lodash';

export const requestBenefits = () => ({
  type: REQUEST_BENEFITS,
});

export const requestBenefitsSuccess = benefits => ({
  type: REQUEST_BENEFITS_SUCCESS,
  benefits,
});

export const requestBenefitsFailure = error => ({
  type: REQUEST_BENEFITS_FAILURE,
  error,
});

export const fetchBenefits = () =>
  (dispatch, getState) => {
    dispatch(requestBenefits());
    const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'GET',
      url: `/api/HrData/HrBenefitPayWage?masterID=${EmployeeMasterID}`,
    };
    custom(config)
      .then(res => dispatch(requestBenefitsSuccess(res.data)))
      .catch(err => dispatch(requestBenefitsFailure(err)));
  };

export const fitnessGrantRegisterRequest = benefitId => ({
  type: FITNESS_GRANT_REGISTER_REQUEST,
  benefitId,
});

export const fitnessGrantRegisterSuccess = benefitId => ({
  type: FITNESS_GRANT_REGISTER_SUCCESS,
  benefitId,
});

export const fitnessGrantRegisterFailure = (error, benefitId) => ({
  type: FITNESS_GRANT_REGISTER_FAILURE,
  benefitId,
  error,
});

export const grantRegisterRequest = () => ({
  type: GRANT_REGISTER_REQUEST,
});

export const grantRegisterSuccess = () => ({
  type: GRANT_REGISTER_SUCCESS,
});

export const grantRegisterFailure = error => ({
  type: GRANT_REGISTER_FAILURE,
  error,
});

export const fitnessGrantRegister = (HrBenefitID, Amount, cb) =>
  (dispatch, getState) => {
    dispatch(fitnessGrantRegisterRequest(HrBenefitID));
    const { loginReducer: { user: { token } } } = getState();
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      method: 'POST',
      url: '/api/EmployeeFitnessGrant/Register',
      data: {
        HrBenefitID,
        Amount,
      },
    };
    custom(config)
      .then(() => {
        if (cb) cb();
        dispatch(addNotification({
          title: 'Móttekið!',
          message: 'Umsókn um styrk var send og mun staða uppfærast næstu mánaðarmót.',
          status: 'success',
          dismissible: true,
          dismissAfter: 16000,
        }));
        dispatch(fitnessGrantRegisterSuccess(HrBenefitID));
        dispatch(fetchBenefits());
      })
      .catch((err) => {
        dispatch(addNotification({
          title: 'Villa',
          message: `Ekki tókst að sækja um styrk. ${get(err, 'Message', '')}`,
          status: 'error',
          dismissible: true,
          dismissAfter: 16000,
        }));
        dispatch(fitnessGrantRegisterFailure(err, HrBenefitID));
      });
  };

const uploadFile = async ({ file, fileType }, idCallBack, ownerType, token, EmployeeMasterID) => {
  try {
    const reader = new FileReader();
    const AddDate = new Date().toISOString();

    const fileResult = await new Promise((resolve, reject) => {
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

    const FileSource = fileResult.substring(fileResult.indexOf(',') + 1);
    const Name = file.name.substring(0, file.name.indexOf('.'));
    const Extension = file.name.substring(file.name.indexOf('.'));

    const config = {
      entity: 'FileRepository',
      headers: { Authorization: `Bearer ${token}` },
      data: {
        EntityType: ownerType.FileRepositoryEntityOwnerTypeID,
        Entity_ID: EmployeeMasterID,
        FileSource,
        ObjectDocumentType: fileType,
        Name,
        Extension,
        AddDate,
      },
    };

    const createResult = await create(config);
    if (idCallBack) {
      idCallBack(createResult.data);
    }
  } catch (error) {
    throw error;
  }
};

export const benefitUpload = ({ files, fileType }, cb, Email, EmailCallBack) =>
  async (dispatch, getState) => {
    dispatch(grantRegisterRequest());
    try {
      const { FileReducer: { ownerTypes }, loginReducer: { user: { token, EmployeeMasterID } } } = getState();
      const uploadPromises = Array.from(files).map(async (file) => {
        const ownerType = find(ownerTypes, ['Value', 'EmployeeMaster']);
        if (ownerType === undefined || !ownerType.FileRepositoryEntityOwnerTypeID) {
          dispatch(addNotification({
            title: 'Villa',
            message: 'Ekki er hægt að vista skjal á EmployeeMaster',
            status: 'error',
            dismissible: true,
            dismissAfter: 16000,
          }));
          return;
        } else if (file === undefined || !file.name) {
          dispatch(addNotification({
            title: 'Villa',
            message: 'Ekki neitt skjal var valið',
            status: 'error',
            dismissible: true,
            dismissAfter: 16000,
          }));
          return;
        }
        await uploadFile({ file, fileType }, cb, ownerType, token, EmployeeMasterID);
      });
      await Promise.all(uploadPromises);
      dispatch(addNotification({
        title: 'Vistað',
        message: 'Viðhengi hefur verið vistað í skjalaskáp',
        status: 'success',
        dismissible: true,
        dismissAfter: 4000,
      }));
      if (Email) {
        EmailCallBack();
      }

      dispatch(grantRegisterSuccess());

    } catch (err) {
      dispatch(addNotification({
        title: 'Villa',
        message: `Ekki tókst að sækja um styrk. ${get(err, 'Message', '')}`,
        status: 'error',
        dismissible: true,
        dismissAfter: 16000,
      }));
      dispatch(grantRegisterFailure(err));
    }
  };

export const fitnessGrantRegisterAndUpload = (HrBenefitID, Amount, files, fileType, cb, Email, EmailCallBack) =>
  async (dispatch, getState) => {
    dispatch(fitnessGrantRegisterRequest(HrBenefitID));
    try {
      const { FileReducer: { ownerTypes }, loginReducer: { user: { token, EmployeeMasterID } } } = getState();
      const uploadPromises = Array.from(files).map(async (file) => {
        const ownerType = find(ownerTypes, ['Value', 'EmployeeMaster']);
        if (ownerType === undefined || !ownerType.FileRepositoryEntityOwnerTypeID) {
          dispatch(addNotification({
            title: 'Villa',
            message: 'Ekki er hægt að vista skjal á EmployeeMaster',
            status: 'error',
            dismissible: true,
            dismissAfter: 16000,
          }));
          return;
        } else if (file === undefined || !file.name) {
          dispatch(addNotification({
            title: 'Villa',
            message: 'Ekki neitt skjal var valið',
            status: 'error',
            dismissible: true,
            dismissAfter: 16000,
          }));
          return;
        }
        await uploadFile({ file, fileType }, cb, ownerType, token, EmployeeMasterID);
      });
      await Promise.all(uploadPromises);
      dispatch(addNotification({
        title: 'Vistað',
        message: 'Viðhengi hefur verið vistað í skjalaskáp',
        status: 'success',
        dismissible: true,
        dismissAfter: 4000,
      }));
      const config = {
        headers: { Authorization: `Bearer ${token}` },
        method: 'POST',
        url: '/api/EmployeeFitnessGrant/Register',
        data: {
          HrBenefitID,
          Amount,
        },
      };

      await custom(config);

      dispatch(addNotification({
        title: 'Móttekið!',
        message: 'Umsókn um styrk var send og mun staða uppfærast næstu mánaðarmót.',
        status: 'success',
        dismissible: true,
        dismissAfter: 4000,
      }));
      if (Email) {
        EmailCallBack();
      }

      dispatch(fitnessGrantRegisterSuccess(HrBenefitID));
      dispatch(fetchBenefits());

    } catch (err) {
      dispatch(addNotification({
        title: 'Villa',
        message: `Ekki tókst að sækja um styrk. ${get(err, 'Message', '')}`,
        status: 'error',
        dismissible: true,
        dismissAfter: 16000,
      }));
      dispatch(fitnessGrantRegisterFailure(err, HrBenefitID));
    }
  };



// WEBPACK FOOTER //
// ./src/actions/Benefits.js